import React from 'react';
import Heading from '@atlaskit/heading';
import { Box, Flex, xcss } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

export const CodeTabWorkSuggestions = () => {
	const { formatMessage } = useIntl();
	return (
		<>
			<Heading size="medium" as="h2">
				{formatMessage(messages.workSuggestionsTitleNonFinal)}
			</Heading>
			<Flex xcss={containerStyles} gap="space.200">
				<Box xcss={suggestionCardStyles}>Suggestion 1</Box>
				<Box xcss={suggestionCardStyles}>Suggestion 2</Box>
				<Box xcss={suggestionCardStyles}>Suggestion 3</Box>
			</Flex>
		</>
	);
};

const containerStyles = xcss({
	backgroundColor: 'elevation.surface.sunken',
	height: '100px',
	padding: 'space.200',
});

const suggestionCardStyles = xcss({
	display: 'flex',
	flex: '1 1 0',
	borderRadius: 'space.050',
	alignItems: 'center',
	justifyContent: 'center',
	color: 'color.text',
});
